/**
 * "This browser belongs to staff" — the one flag that keeps every analytics
 * sink (Meta Pixel + CAPI twin, PostHog, GA) quiet for staff / test sessions.
 *
 * 2026-09-06: of the 150 InitiateCheckout events in the day's Meta dataset,
 * ~147 were staff testing the new /plans and 3 were real users — and Meta
 * optimises ad delivery on that dataset. The value comes from `/auth/me`
 * (`user.internal`, applied in auth-context) and is remembered in localStorage
 * so it also covers the anonymous page loads before the session resolves and
 * the logged-out testing that follows on the same browser. A later login by a
 * NON-internal user on that browser clears it.
 *
 * Kept in its own module (not tracking.ts) so posthog.ts can read it without
 * importing the Meta/GA layer — several tests mock `./tracking` wholesale.
 */
const INTERNAL_VIEWER_KEY = 'uzt:internal';
let internalViewer: boolean | null = null;

export function isInternalViewer(): boolean {
  if (internalViewer === null) {
    try {
      internalViewer = localStorage.getItem(INTERNAL_VIEWER_KEY) === '1';
    } catch {
      internalViewer = false;
    }
  }
  return internalViewer;
}

export function setInternalViewer(internal: boolean): void {
  internalViewer = internal;
  try {
    if (internal) localStorage.setItem(INTERNAL_VIEWER_KEY, '1');
    else localStorage.removeItem(INTERNAL_VIEWER_KEY);
  } catch {
    // storage unavailable — the in-memory flag still covers this page
  }
}
